// extracted by mini-css-extract-plugin
export default {"chart-type-selector":"R_f0"};